import type { IFormxRepository, FieldCreateInput } from '../repositories/IFormxRepository.js';
import type { FormxFieldEntity } from '../entities/FormxEntity.js';

interface Deps { formxRepository: IFormxRepository; }

export function createCreateFormxFieldUseCase({ formxRepository }: Deps) {
  return async function createFormxField(input: FieldCreateInput): Promise<FormxFieldEntity> {
    return formxRepository.createField(input);
  };
}
